import React, { useEffect, useState } from "react";
import "./CMNewsSection.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";

export default function CMNewsSection() {
  const { i18n } = useTranslation();
  const lang = i18n.language || "ta"; // language from header
  const [newsData, setNewsData] = useState([]);

  useEffect(() => {
    axios
      .get("https://admin.cmpranesh-admk.com/api/getNews.php") 
      .then(res => setNewsData(res.data))
      .catch(err => console.error("Error fetching news:", err));
  }, []);

  // Prepare tags safely
  const allTags = [...new Set(
    newsData.flatMap(n => {
      const tags = lang === "ta" ? n.tags_ta : n.tags_en;
      return (tags || "").split(",").map(t => t.trim()).filter(t => t);
    })
  )];

  return (
    <section className="cm-news-wrapper">
      {/* MAIN TITLE BASED ON LANGUAGE */}
      <h1 className="cm-news-main-title">
        {lang === "en"
          ? "🗞️ Latest Political News & Updates"
          : "🗞️ சமீபத்திய அரசியல் செய்திகள் & புதுப்பிப்புகள்"}
      </h1>

      <div className="cm-news-main">
        {/* LEFT SIDE NEWS LIST */}
        <div className="cm-news-left">
          {newsData.map(news => (
            <div key={news.id} className="cm-news-big-card">
              <div className="cm-news-big-date">
                {new Date(news.date).toLocaleDateString(
                  lang === "ta" ? "ta-IN" : "en-US",
                  { day: "2-digit", month: "short", year: "numeric" }
                )}
              </div>
              <img
                src={`https://admin.cmpranesh-admk.com/${news.image}`}
                className="cm-news-big-image"
                alt={lang === "ta" ? news.title_ta : news.title_en}
              />
              <h2 className="cm-news-big-title">
                {lang === "ta" ? news.title_ta : news.title_en}
              </h2>
              <p className="cm-news-big-content">
                {lang === "ta" ? news.shortDesc_ta : news.shortDesc_en}
              </p>
              <Link to={`/news/${news.id}`} className="cm-news-readmore">
                {lang === "en" ? "Read More →" : "மேலும் படிக்க →"}
              </Link>
            </div>
          ))}
        </div>

        {/* RIGHT SIDEBAR */}
        <div className="cm-news-right">
          {/* Recent Posts */}
          <div className="cm-news-sidebar-box">
            <h3>{lang === "en" ? "📌 Recent Posts" : "📌 சமீபத்திய பதிவுகள்"}</h3>
            <ul>
              {newsData.map(post => (
                <li key={post.id}>
                  <Link to={`/news/${post.id}`}>
                    {lang === "ta" ? post.title_ta : post.title_en}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Tags */}
          <div className="cm-news-sidebar-box">
            <h3>{lang === "en" ? "🏷️ Tags" : "🏷️ குறிச்சொற்கள்"}</h3>
            <div className="cm-news-tags">
              {allTags.map((tag, index) => (
                <span key={index} className="cm-tag-item">
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
